export default __webpack_public_path__ + "static/media/9.4a38a1dc.png";